import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "@mui/material";
import SFAuthorized from "../../../authorized";
import getStyled from "../../../../hooks/getStyled";
import SFAvatar from "../../../avatar";
import { SFStack } from "../../../grid";

const { theme, styled } = getStyled();

const AvatarStyled = styled(SFAvatar)(({ bgColor, theme }) => ({
  width: "30px",
  height: "30px",
  display: "inline-flex",
  marginRight: theme.spacing(1.5),
  fontSize: "12px",
  fontWeight: 300,
  ...(bgColor && { backgroundColor: bgColor }),
}));

const StyledLink = styled(Link)(() => ({
  cursor: "pointer",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

let avatarColors = [
  theme.palette.blue400.main,
  theme.palette.purple200.main,
  theme.palette.red500.main,
  theme.palette.teal500.main,
  theme.palette.orange500.main,
  theme.palette.maroon300.main,
  theme.palette.green300.main,
];

const SFEditRenderer = ({
  context,
  data,
  value,
  column,
  colDef,
  onClick,
  ...props
}) => {
  const [avatarSrc, setAvatarScr] = useState(null);

  useEffect(() => {
    if (colDef.avatar && value && colDef.cellRendererParams?.getAvatar) {
      colDef.cellRendererParams.getAvatar(data).then((res) => {
        setAvatarScr(res);
      });
    }
  }, []);

  return (
    <SFAuthorized permissions={context.permissions?.edit}>
      <SFStack spacing={0.5} direction="row" alignItems="center">
        {colDef.avatar &&
          value &&
          (data.avatar || avatarSrc ? (
            <AvatarStyled src={data.avatar ?? avatarSrc} />
          ) : (
            <AvatarStyled
              bgColor={
                avatarColors[Math.floor(Math.random() * avatarColors.length)]
              }
              name={data.name}
            />
          ))}
        <StyledLink
          onClick={() => onClick(data)}
          variant={colDef.variant ?? colDef.context?.variant ?? "gridUrlRender"}
        >
          {value}
        </StyledLink>
      </SFStack>
    </SFAuthorized>
  );
};

SFEditRenderer.propTypes = {
  value: PropTypes.any,
  variant: PropTypes.string,
  column: PropTypes.any,
};

export default SFEditRenderer;
